import logo from './logo.svg';
import './App.css';
import 'antd/dist/antd.css';
import { Input, Space, Card } from 'antd';
import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactGA from "react-ga4";

ReactGA.initialize("G-2PQ3K9XS35");

function App() {
  const [result, setResult] = useState([])
  const [term, setTerm] = useState('best+foundation')
  const [search, setSearch] = useState('')
  const { Search } = Input;
  var searchTerm = 'best+foundation'
  

  
  const onSearch = (value) => {
    setSearch(value)

    ReactGA.event("search_click",{
      category: "process",
      action: "complete",
      label: value
    });

    if(value != ''){
      setResult(<div style={{margin: 20 + 'px'}}><img style={{width: 20 + 'px'}} src="https://acegif.com/wp-content/uploads/loading-45.gif"></img><p>Warming up. This may take 1 minute...</p></div>)
      
      searchTerm = value.replaceAll(' ', '+');
      setTerm(searchTerm)
    }
    

    const baseURL = "https://ambiguous-snowy-reaper.glitch.me/search"
    var country = "&gl=us"
    var searchStart = "&q="


    axios.post(baseURL,
      {search: value,},
      {
        headers: {
          // 'application/json' is the modern content-type for JSON, but some
          // older servers may use 'text/json'.
          // See: http://bit.ly/text-json
          //'content-type': 'text/json',
          'Access-Control-Allow-Origin': '*'
        }
      }
    ).then((response) => {

      console.log(response.data)
      
      var text, parser, xmlDoc;

      text = response.data
      parser = new DOMParser();
      xmlDoc = parser.parseFromString(text,"text/xml");
      console.log(xmlDoc.getElementsByTagName("suggestion")[0].getAttribute('data'))
      const output = xmlDoc.getElementsByTagName("suggestion")
      console.log("output",output)
    
      var names = []

      for (let i = 0; i < output.length; i++) {
        names.push(<Card class="result">{output[i].getAttribute('data')} <span class="float-right grad-text">Volume: <span class="blurry-text">10.4k</span> Unlock 👆</span></Card>)
      }

            setResult(names)
    });

 
  };

  const openWindow = () => {
    window.open("https://app.mangools.com/kwfinder/dashboard?language_id=0&location_id=0&query="+term+"&source_id=0&utm_campaign=affiliate_kwfinder&utm_content=html5_banner&utm_medium=affiliate#a63e1447f6aee083b3fd41b04")
   }
  

  return (
    <div className="App">
      <header >
        <Search
        placeholder="best foundations"
        allowClear
        enterButton="Search"
        size="large"
        onSearch={onSearch}
      />
      <div class="unlock-btn" onClick={() => openWindow()}>Unlock <span style={{color:"lightgreen"}}>{search}</span> keyword volumes ↗️</div>
      {result}
      </header>
    </div>
  );
}

export default App;
